<template>
  <div>
    <form data-vv-scope="step-1-part-1" autocomplete="off" @submit.prevent>
      <div class="row mb-3">
        <div class="col-12">
          <list-document-types
            class="w-100"
            autocomplete
            label="Tipo Documento (*)"
            data-cy="document-type"
            name="documentType"
            v-model="step.documentType"
            :danger="errors.has('step-1-part-1.documentType')"
            :danger-text="errors.first('step-1-part-1.documentType')"
            v-validate="'required'"
            ref="documentTypes"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <vs-input
            class="w-100"
            label="Nº Documento (*)"
            data-cy="document-number"
            name="documentNumber"
            v-model="step.documentNumber"
            v-validate="'required'"
            :danger="errors.has('step-1-part-1.documentNumber')"
            :danger-text="errors.first('step-1-part-1.documentNumber')"
            autocomplete="off"
            data-vv-as="nº documento"
            ref="documentNumber"
          />
        </div>
        <div class="col-md-6">
          <b-form-group
              label="Empresa (*)"
          >
            <v-select
                class="w-100 b-radius"
                v-model="step.author"
                :options="authorAguasAndinas"
                :clearable="false"
                data-cy="author"
                name="author"
                data-vv-as="autor"
                v-validate="'required'"
                :class="{
                'v-select-danger': errors.has('step-1-part-1.author'),
                'select-size-sm': errors.has('step-1-part-1.author')
              }"
            />
            <div
                v-if="errors.has('step-1-part-1.author')"
                class="con-text-validation span-text-validation-danger v-enter-to"
                style="height: 19px;"
            >
              <span class="span-text-validation">
                {{ errors.first('step-1-part-1.author') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6 mt-1">
          <label>Fecha Documento</label>
          <b-form-datepicker
              today-button
              reset-button
              close-button
              v-bind="labels[locale] || {}"
              :max="maxDate"
              :locale="locale"
              :show-decade-nav="false"
              :hide-header="false"
              v-model="step.issueDate"
          />
        </div>
        <div class="col-md-6 mt-1">
          <label>Plazo de gestión</label>
          <b-form-datepicker
              data-cy="management-calendar"
              today-button
              reset-button
              close-button
              v-bind="labels[locale] || {}"
              :min="minExpirationDate"
              :locale="locale"
              :show-decade-nav="false"
              :hide-header="false"
              v-model="step.expirationDate"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <b-form-group
            label="Tema (*)"
          >
            <v-select
              class="w-100 b-radius"
              v-model="step.theme"
              :options="themesAguasAndinas"
              :clearable="false"
              :reduce="option => option.id"
              data-cy="theme"
              name="theme"
              data-vv-as="tema"
              v-validate="'required'"
              :class="{
                'v-select-danger': errors.has('step-1-part-1.theme'),
                'select-size-sm': errors.has('step-1-part-1.theme')
              }"
            />
            <div
              v-if="errors.has('step-1-part-1.theme')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
              <span class="span-text-validation">
                {{ errors.first('step-1-part-1.theme') }}
              </span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-6">
          <b-form-group
            label="Sub-tema (*)"
          >
            <v-select
              class="w-100 b-radius"
              v-model="step.subTheme"
              :options="subThemesAguasAndinas"
              :reduce="option => option.id"
              :clearable="false"
              data-cy="sub-theme"
              name="subtheme"
              data-vv-as="sub-tema"
              v-validate="'required'"
              :class="{
                'v-select-danger': errors.has('step-1-part-1.subtheme'),
                'select-size-sm': errors.has('step-1-part-1.subtheme')
              }"
            />
            <div
              v-if="errors.has('step-1-part-1.subtheme')"
              class="con-text-validation span-text-validation-danger v-enter-to"
              style="height: 19px;">
              <span class="span-text-validation">
                {{ errors.first('step-1-part-1.subtheme') }}
              </span>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <label for="matter">Materia (*)</label>
          <vs-textarea
            type="text"
            id="matter"
            label="Materia (Mínimo 3 caracteres, máximo 5000 caracteres)"
            data-cy="matter"
            name="matter"
            width="100%"
            v-validate="'required|min:3'"
            height="100px"
            maxlength="5000"
            class="mb-0"
            v-model="step.matter"
          />
          <div v-if="errors.first('step-1-part-1.matter')"
            class="con-text-validation span-text-validation-danger
             vs-input--text-validation-span v-enter-to"
            style="height: 32px;">
            <span class="span-text-validation">
              {{errors.first('step-1-part-1.matter')}}
            </span>
          </div>
          <div class="text-right">
            <span v-tooltip="'Contador de caracteres'">{{step.matter.length}}/5000</span>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <label for="tags">Etiquetas</label>
          <vue-tags-input
            id="tags"
            class="w-100 b-radius"
            v-model="tag"
            data-cy="tags"
            name="tags"
            :tags="step.tags"
            @tags-changed="newTags => step.tags = newTags"
            placeholder="Agregar"
            :separators="[',']"
          />
        </div>
        <div class="col-md-6">
          <b-form-group
            label="Es documento madre"
          >
            <v-select
              data-cy="is-mother"
              class="w-100 b-radius"
              v-model="step.isMother"
              :options="optionsMother"
              :clearable="false"
              :reduce="option => option.id"
            />
          </b-form-group>
        </div>
      </div>
      <div class="row mb-3" v-if="!validMother">
        <div class="col-md-6">
          <vs-input
            autocomplete="off"
            class="w-100"
            data-cy="mother-document-number"
            label="Nº Documento Madre (*)"
            v-model.trim="step.documentNumberMother"
            data-vv-as="documento madre"
            v-validate="{ required: !validMother }"
            name="documentNumberMother"
            v-on:keyup="searchForMother()"
            :danger="errors.has('step-1-part-1.documentNumberMother')"
            :danger-text="errors.first('step-1-part-1.documentNumberMother')"
          />
          <ul id="list"
              v-if="(motherDocumentsList.length > 0 || loadingMotherDocuments) && showListSelect">
            <li v-if="loadingMotherDocuments">
              <span class="muted-light">Buscando...</span>
            </li>
            <li v-for="item in motherDocumentsList"
                @click="setDocumentMother(item)"
                v-bind:key="item.numero"
            >
              <span>{{ item.numero }}</span>
              <span class="muted-light">
                creado el {{ formatDate(item.fechaCreacion) }}
              </span>
              <span class="muted-light">
                nº interno {{item.numeroInt}}
              </span>
              <p>Creado por <b>{{ item.solicitanteNombre}}</b> ({{ item.solicitanteEmail}})</p>
            </li>
          </ul>
          <small class="text-danger" v-if="error.message">{{error.message}}</small>
        </div>
        <div class="col-md-6">
          <label>Fecha Documento Madre</label>
          <b-form-datepicker
            today-button
            reset-button
            close-button
            v-bind="labels[locale] || {}"
            :max="maxDate"
            :locale="locale"
            :show-decade-nav="false"
            :hide-header="false"
            v-model="step.issueDateMother"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <vs-divider />
        </div>
      </div>
    </form>
    <form data-vv-scope="step-1-part-2" autocomplete="off" @keydown.enter.prevent>
      <div class="row mb-3">
        <div class="col-12">
          <h4>Documentos Relacionados</h4>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <list-document-types
            class="w-100"
            autocomplete
            label="Tipo Documento"
            data-cy="relate-document-type"
            name="relatedDocumentType"
            v-model="relatedDocument.type"
            :danger="errors.has('step-1-part-2.relatedDocumentType')"
            :danger-text="errors.first('step-1-part-2.relatedDocumentType')"
            v-validate="'required'"
            data-vv-as="tipo documento"
            ref="relatedDocumentType"
          />
        </div>
        <div class="col-md-6">
          <vs-input
            class="w-100"
            label="Nº Documento"
            data-cy="related-document-number"
            name="relatedDocumentNumber"
            v-model="relatedDocument.number"
            v-validate="'required'"
            :danger="errors.has('step-1-part-2.relatedDocumentNumber')"
            :danger-text="errors.first('step-1-part-2.relatedDocumentNumber')"
            autocomplete="off"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12 d-flex align-items-end justify-content-end">
          <vs-button
            data-cy="add-relation"
            color="primary"
            icon="add"
            v-on:click="addRelatedDocument()">
            Agregar relación
          </vs-button>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12">
          <vs-table
            class="pb-2 mb-2"
            multiple
            v-model="step.relatedDocumentsSelected"
            no-data-text="No tienes documentos relacionados"
            :data="step.relatedDocuments"
          >
            <template slot="thead">
              <vs-th>Relacionado con</vs-th>
              <vs-th>Nº Documento</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                <vs-td :data="data[indextr].type">
                  {{ findLabelDocument(tr.type) }}
                </vs-td>
                <vs-td :data="data[indextr].number">
                  {{ tr.number }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import VueTagsInput from '@johmun/vue-tags-input'; // docs: http://www.vue-tags-input.com/#/api/props
import { mapGetters } from 'vuex';

import WizardStep from '@/febos/chile/dnt/mixins/WizardStep';
import ListDocumentTypes from '@/febos/chile/lists/components/ListDocumentTypes';
import FindTypeDocumentMixin from '@/febos/chile/dnt/mixins/FindTypeDocumentMixin';
import Themes from '@/febos/chile/dnt/components/wizard/companies/61808000-5/utils/Themes';
import { ioExpedientesSearch } from '@/febos/servicios/api/busqueda.api';
import FindLabelDocumentMixin from '@/febos/chile/dnt/mixins/FindLabelDocumentMixin';
import authors from '@/febos/chile/dnt/components/wizard/companies/61808000-5/utils/Authors';

export default {
  mixins: [WizardStep, FindTypeDocumentMixin, FindLabelDocumentMixin],
  components: {
    VueTagsInput,
    ListDocumentTypes
  },
  data() {
    return {
      locale: 'es',
      labels: {
        es: {
          labelPrevDecade: 'Década anterior',
          labelPrevYear: 'Año anterior',
          labelPrevMonth: 'Mes anterior',
          labelCurrentMonth: 'Mes actual',
          labelNextMonth: 'Mes siguiente',
          labelNextYear: 'Año siguiente',
          labelNextDecade: 'Década siguiente',
          labelToday: 'Hoy',
          labelSelected: 'Fecha seleccionada',
          labelNoDateSelected: 'Sin fecha seleccionada',
          labelCalendar: 'Calendario',
          labelNav: 'Navegación calendario',
          labelHelp: 'Use las teclas del cursor para navegar por las fechas del calendario',
          labelReset: 'Borrar',
          'label-today-button': 'Hoy',
          'label-reset-button': 'Borrar',
          'label-close-button': 'Cerrar'
        }
      },
      tag: '',
      typeNumeration: this.$route.params.wizard,
      disabledDates: {
        from: new Date()
      },
      step: {
        documentType: '',
        documentNumber: '',
        issueDate: '',
        matter: '',
        tags: [],
        isPrivate: '0',
        isMother: '1',
        documentNumberMother: '',
        issueDateMother: '',
        relatedDocumentsSelected: [],
        relatedDocuments: [],
        subTheme: '',
        idCompany: '',
        idUser: '',
        theme: '',
        references: {},
        ...this.draft
      },
      optionsMother: [{ label: 'Si', id: '1' }, { label: 'No', id: '0' }],
      relatedDocument: {
        type: '',
        number: ''
      },
      temas: Themes,
      themesAguasAndinas: [],
      authorAguasAndinas: authors,
      counterDanger: false,
      showListSelect: false,
      loadingMotherDocuments: false,
      motherDocumentsFullList: [],
      error: {
        message: ''
      }
    };
  },
  computed: {
    ...mapGetters('Dnts', ['communes', 'loading', 'wizardStorage', 'detailsFile']),
    ...mapGetters('List', [
      'documentsState'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUserId'
    ]),
    ...mapGetters('List', [
      'allDocumentsState'
    ]),
    motherDocumentsList() {
      const result = this.motherDocumentsFullList.filter(
        (x) => {
          try {
            return x.numeroInt.includes(this.step.documentNumberMother);
          } catch (e) {
            return false;
          }
        }
      ).slice(0, 5);
      if (typeof result === 'undefined') return [];
      return result;
    },
    maxDate() {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      return new Date(today);
    },
    minExpirationDate() {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      return new Date(today);
    },
    isRequired() {
      let documents = this.documentsState.list;
      if (this.typeNumeration === 'numOf') {
        documents = this.documentsState.list
          .filter((group) => group.extra.numOf);
      }
      if (this.typeNumeration === 'numInt') {
        documents = this.documentsState.list
          .filter((group) => group.extra.numInt);
      }
      return documents.length > 0;
    },
    subThemesAguasAndinas() {
      const result = this.temas.find((el) => el.tema.id === this.step.theme);
      if (this.step.theme === '') {
        return [];
      }
      return result && result.subtema;
    },
    validMother() {
      // eslint-disable-next-line
      return !!parseInt(this.step.isMother);
    }
  },
  methods: {
    findLabel(document) {
      return this.allDocumentsState.list
        .find((option) => option.value === document) || {};
    },
    async isValid() {
      if (!this.validMother && this.step.documentNumberMother.length > 0
        && this.motherDocumentsFullList.length > 0) {
        this.error.message = '';
      }
      return this.validateForm('step-1-part-1');
    },
    getStepData() {
      const documentTypeName = this.step.documentType
        ? {
          documentTypeName: this.$refs.documentTypes.getOption().label
        }
        : {};
      const documentTypeId = this.step.documentType
        ? {
          documentTypeId: this.$refs.documentTypes.getOption().id
        }
        : {};
      return {
        ...this.step,
        ...documentTypeName,
        ...documentTypeId
      };
    },
    async addRelatedDocument() {
      if (this.step.safiContract === '') {
        this.$bvToast.toast(
          'Te recordamos que no estas ingresando el número de Contrato SAFI',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      }

      const isValid = await this.validateForm('step-1-part-2');

      if (!isValid) {
        return;
      }

      const row = {
        id: this.relatedDocument.length,
        type: this.relatedDocument.type,
        number: this.relatedDocument.number
      };
      const isSelected = this.step.relatedDocumentsSelected
        .some((relatedDoc) => relatedDoc.id === row.id
          && relatedDoc.type === row.type && relatedDoc.number === row.number);

      if (!isSelected) {
        this.step.relatedDocuments.push(row);
        this.step.relatedDocumentsSelected.push(row);
      } else {
        this.$bvToast.toast(
          'Ya agregaste esta referencia',
          {
            title: '¡HEEEY!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      }

      this.relatedDocument.type = '';
      this.relatedDocument.number = '';
      await this.$validator.reset();
    },
    async searchForMother() {
      this.showListSelect = true;
      this.loadingMotherDocuments = true;
      const payload = {
        params: {
          elementosPorPagina: 5,
          pagina: 1,
          filtros: `numeroInt:${this.step.documentNumberMother}|emisorRut:${this.company.iut}|estado:!!!3|estadoCodigoEstadoComprador:1`,
          orden: '-fechaCreacion'
        }
      };
      try {
        const res = await ioExpedientesSearch(payload);
        const that = this;
        res.data.documentos.forEach((element) => that.motherDocumentsFullList.push(element));
        const keys = ['numeroInt', 'fechaCreacion'];
        this.motherDocumentsFullList = this.motherDocumentsFullList.filter(
          // this basically delete duplicates, using added keys before
          ((s) => (o) => ((k) => !s.has(k) && s.add(k))(keys.map((k) => o[k]).join('|')))(new Set())
        );
        if (!this.motherDocumentsFullList.length) {
          this.setDocumentMother({
            numero: this.step.documentNumberMother,
            febosId: '',
            codigo: 'mother',
            linea: '1',
            tipoDocumento: 'EXP'
          });
        }
      } catch (e) {
        // nothing to do
      }
      this.loadingMotherDocuments = false;
    },
    formatDate(fullDate) {
      const date = fullDate.split(' ')[0];
      const year = date.split('-')[0];
      const month = date.split('-')[1];
      const day = date.split('-')[2];
      const months = ['', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto',
        'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      return `${day} de ${months[parseInt(month, 10)]}, ${year}`;
    },
    setDocumentMother(item) {
      this.step.documentNumberMother = item.numero;
      this.showListSelect = false;
      this.error.message = '';
      this.step.references = {
        linea: 1,
        tipoDocumento: 'EXP',
        folio: item.numero,
        otraReferenciaId: item.febosId,
        codigo: 'mother',
        documentoId: item.febosId
      };
    }
  },
  created() {
    this.themesAguasAndinas = this.temas.map((el) => el.tema);

    this.step.idCompany = this.company.id;
    this.step.idUser = this.currentUserId;
  },
  watch: {
    // eslint-disable-next-line
    'step.theme': function (newValue, oldValue) {
      if (oldValue) {
        if (newValue !== oldValue) {
          this.step.subTheme = '';
        }
      }
    }
  }

};

</script>
<style>
.ti-input {
  border-radius: 5px !important;
}
</style>

<style scoped>
#list {
  font-size: 12px;
  list-style: none;
  margin: 0;
  padding: 5px 0;
  background-color: white;
  border-radius: 0 0 5px 5px;
  border: 1px #ccc solid;
  position: absolute;
  z-index:100;

}

#list li {
  display: block;
  padding: 5px 15px;
}

#list li:hover {
  background-color: #ccc;
  /*   color: white; */
}

#list li span {
  font-weight: 550;
}

#list li p {
  margin: 5px 0 0;
}
.muted-light{
  color:#aaa;
  font-weight:100;
}
</style>
